/* c8 ignore start */
import { createSSRApp } from 'vue';
import App from './OffPrice.vue';

export default function createApp(props) {
  const app = createSSRApp(App, props);
  return { app };
}
